<template>
    <div>
        <b-row>
        <b-col class="d-flex justify-content-end">
          <b-button class="btn btn-success" @click="onShowModalCreate()">Crear</b-button>
          <b-button
            class="ml-1"
            variant="success"
            size="sm"
            @click="descargarCartAten"
            v-b-tooltip.hover
            title="Descargar Cartera At"
          >
          <div v-if="descargandoExcel">
              <b-spinner small type="grow"></b-spinner>
              <label style="color: whitesmoke;">Descargando..</label> 
            </div>
          <i class="fas fa-file-excel"></i>
        </b-button>  
        </b-col>
      </b-row>

        <b-row class="mt-2">
            <b-col md="8">
                <b-form-group>
                    <b-form-input v-model="consultaratencion"
                        placeholder="Buscar por nombre o código de la atencion medica." type="text"
                        class="d-inline-block" />
                </b-form-group>
            </b-col>
            <b-col md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <b-form-group class="w-100">
                    <v-select id="establecimiento" v-model="consultarestablecimiento" :options="establecimientos"
                        :reduce="option => option.value" placeholder="Buscar por establecimiento." label="text"
                        class="d-inline-block w-100" />
                </b-form-group>
            </b-col>
            <b-col md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <b-form-group class="w-100">
                    <v-select id="estado" v-model="estado" placeholder="Seleccionar estado." :options="estados"
                        :reduce="option => option.value" label="text" class="d-inline-block w-100" />
                </b-form-group>
            </b-col>
        <b-col cols="12" md="4" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <b-button variant="primary" @click="cambiarEstadoIds">
                    <span style="color: white;">
                        Cambiar estado</span>
                </b-button>

            </b-col>
            <b-col cols="12" md="4" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <b-button variant="primary" @click="buscarAtencion">
                    <font-awesome-icon icon="magnifying-glass" style="color: white;" /> <span style="color: white;">
                        buscar</span>
                </b-button>
            </b-col>
        </b-row>
        <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
            <b-card class="principal">
                <b-col cols="12" class="pr-0 pl-0 mt-2">
                    <b-table v-if="items.length > 0" bordered striped responsive :per-page="perPage"
                        :current-page="currentPage" :items="items" :fields="fields" :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
                        :filter-included-fields="filterOn" @filtered="onFiltered">
                        <template #cell(check)="data">
                            <b-form-checkbox @change="selectedAtencion(data.item.idAtencion)">

                            </b-form-checkbox>
                        </template>
                        <template #cell(estadoJson)="data">
                          <div class="row">
                            <label class="col-6">Iess: <label :class="data.item.estadoJson.iess ? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.iess ? 'Activo' : 'Inactivo' }} </label> </label> 
                            <label class="col-6">Issfa: <label :class="data.item.estadoJson.issfa ? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.issfa ? 'Activo' : 'Inactivo' }} </label> </label> 
                            <label class="col-6">Isspol: <label :class="data.item.estadoJson.isspol ? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.isspol ? 'Activo' : 'Inactivo' }} </label> </label> 
                            <label class="col-6">Particular: <label :class="data.item.estadoJson.particular ? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.particular ? 'Activo' : 'Inactivo' }} </label> </label> 
                          </div>
                        </template>
                        <template #cell(acciones)="data">
                            <div class="d-flex justify-content-end">
                                <b-button variant="info" size="sm" @click="viewItem(data.item.tokenAtencion)">
                                    <font-awesome-icon icon="magnifying-glass" style="color: white;" />
                                </b-button>
                                <b-button variant="primary" size="sm" @click="editItem(data.item.tokenAtencion)">
                                    <font-awesome-icon icon="user-pen" style="color: white;" />
                                </b-button>
                                <b-button variant="danger" size="sm"
                                    @click="fetchRemoveItemAtencion(data.item.idAtencion)">
                                    <font-awesome-icon icon="circle-xmark" style="color: white;" />
                                </b-button>
                            </div>
                        </template>
                        <template #cell(descripcion)="data">
                            <div :id="'tooltip-target-' + data.index" v-b-tooltip.hover :title="data.item.descripcion">
                                {{ truncateTexto(data.item.descripcion, 50) }}
                            </div>
                        </template>

                        <template #cell(establecimientos)="data">
                          <div class="d-flex flex-column">
                            <span
                              v-for="est in data.item.establecimientos"
                              :key="est.id"
                            >
                              {{ est.nombre }}:
                              <span :class="est.activo ? 'text-success' : 'text-danger'">
                                {{ est.activo ? 'Activo' : 'Inactivo' }}
                              </span>
                            </span>
                          </div>
                        </template>
                    </b-table>
                    <div v-else class="text-center">
                        <p>No se encontraron registros</p>
                    </div>
                </b-col>
                <b-col cols="12" class="mb-2">
                    <b-pagination v-if="items.length > 0" v-model="currentPageModificado" :total-rows="totalRows"
                        :per-page="perPage" :small="true" first-number last-number class="mb-0" align="center"
                        prev-class="prev-item" next-class="next-item" @change="cambiarPagina">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </b-col>
            </b-card>
        </b-overlay>
     
        <b-modal id="modal-ver-atencion" title="Ver Atencion" size="md">
            <ver-item-cartera-atencion :token="tokenAtencion" />
        </b-modal>
        <b-modal id="modal-editar-atencion" @ok="submitChildForm" ok-title="Actualizar Item" title="Editar Atencion"
            size="lg">
            <editar-item-cartera-atencion ref="EditarItemCarteraAtencion" :token="tokenAtencion" />

        </b-modal>
    </div>

</template>

<script>
import {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BOverlay,
    BFormGroup,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
} from 'bootstrap-vue'
import actions from '@/assets/utils/utils'
import BCardCode from '@core/components/b-card-code'
import vSelect from 'vue-select'
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import VerItemCarteraAtencion from './VerItemCarteraAtencion.vue';
import { comprobarPermisos, getEstablecimientoLS } from "@/shared/helpers";
import EditarItemCarteraAtencion from './EditarItemCarteraAtencionV2.vue';
//import Editarimagen from "./Editarimagen.vue";


export default {
    components: {
        BCard,
        BCardCode,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BButton,
        BTable,
        BMedia,
        BAvatar,
        BOverlay,
        BLink,
        BBadge,
        VerItemCarteraAtencion,
        EditarItemCarteraAtencion,
        
        BDropdown,
        BDropdownItem,
        BPagination,
        BTooltip,
        vSelect,
    },
    data() {

        return {
            descargandoExcel: false,
            tokenSeleccionado: null,
            modalShow: false,
            componenteDinamico: null,
            pagina_actual: 1,
            currentPage: 1,
            currentPageModificado: 1,
            mostrarLoader: false,
            login_user: '',
            consultaratencion: null,
            consultarestablecimiento: '',
            establecimientos: [],
            establecimientosMap: {},
            establecimiento: '',
            currentEstablecimiento: getEstablecimientoLS && getEstablecimientoLS(),
            consultartipoImagen: '',
            tipoImagen: '',
            tiposImagen: [],
            perPage: 15,
            pageOptions: [3, 5, 10],
            totalRows: 3,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            tokenAtencion: null,
            infoModal: {
                id: 'info-modal',
                title: '',
                content: '',
            },
            fields: [
                { key: 'check', label: '', thClass: 'text-center' },
                { key: 'estadoJson', label: 'Estado', sortable: true, thClass: 'text-center', thStyle: { width: '180px' }, tdClass: 'col-estado' },
                { key: 'establecimientos', label: 'Establecimientos', sortable: true, thClass: 'text-center', thStyle: { minWidth: '260px', width: '260px' }, tdClass: 'col-establecimientos text-left' },
                { key: 'descripcion', label: 'Nombre', sortable: true, thClass: 'text-center', thStyle: { minWidth: '260px', width: '260px' }, tdClass: 'col-nombre text-left' },
                { key: 'codTarifa', label: 'Codigo', sortable: true, thClass: 'text-center' },
                { key: 'usuario', label: 'Usuario', sortable: true, thClass: 'text-center' },
                { key: 'acciones', label: 'acciones', sortable: true, thClass: 'text-center', tdClass: 'text-right' },

            ],
            listaAcciones: [],
            token_usuario: '',
            configdateTimePicker: {
                enableTime: false,
                dateFormat: 'd/m/Y',
            },
            items: [],
            descripcion: '',
            idsAtenciones: [],
            estado: null,
            estados: [
                { value: '1', text: 'Activo' },
                { value: '0', text: 'Inactivo' }
            ],
        }
    },
    async created() {
        comprobarPermisos(this.$route);
        this.setToken();
        await this.fetchEstablecimientos();
        await this.fetchConsultarAtencionesMedicas();


    },
    mounted() {
        actions.setearTitulo('Cartera Atenciones Medicas')
       


    },
    methods: {
        async cambiarEstadoIds() {
            if (!this.estado) {
                this.$swal.fire({
                    icon: "info",
                    text: "Por favor, seleccione un estado."
                })
            } else if (this.estado && this.idsAtenciones.length === 0) {
                this.$swal.fire({
                    icon: "info",
                    text: "Por favor, seleccione al menos una atencion."
                })
            } else {
                const query = ` mutation cambiarItemAtencionEstado($atencionDatos: ItemAtencionEstadoInput!) {
                                cambiarItemAtencionEstado(atencionDatos: $atencionDatos) {
                                    status
                                    message
                                }
                                } `


                let variables = {
                    atencionDatos: {
                        id: this.idsAtenciones,
                        estado: this.estado,
                    }
                }

                try {

                    const response = await axios.post(rutas.axios + 'api', { query, variables });

                    if (response.data.data.cambiarItemAtencionEstado.status === 'SUCCESS') {
                        await this.$swal.fire({
                            title: 'Exito',
                            icon: 'success',
                            text: 'Estado de atenciones actualizados correctamente!'
                        })
                        this.$router.go(0)
                    }
                } catch (error) {
                    console.error('Erro:', error);
                }
            }
        },
        selectedAtencion(id) {
            const index = this.idsAtenciones.indexOf(id);

            if (index !== -1) {

                this.idsAtenciones.splice(index, 1);
            } else {

                this.idsAtenciones.push(id);
            }

        },
        async submitChildForm() {

            if (this.$refs.EditarItemCarteraAtencion) {
                await this.$refs.EditarItemCarteraAtencion.submitForm();
            }
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            console.log("estoy cansado jefe", this.currentPage)
        },
        cambiarPagina(pagina_actual) {
            // Actualizar currentPage con el nuevo número de página
            this.currentPage = pagina_actual;
            console.log("Nueva página actual:", this.currentPage);
            const establecimientoValue = this.consultarestablecimiento ? this.consultarestablecimiento.toString() : '';
            this.fetchConsultarImagen(this.consultaratencion ? this.consultaratencion : '', this.currentPage, establecimientoValue, this.perPage);
            console.log("hey", pagina_actual)
        },
        async fetchEstablecimientos() {
            const query = `
                        query {
                            allEstablecimientos {
                                id
                                Descripcion
                                uniCodigo
                            }
                        }
                    `;
            try {
                const response = await axios.post(rutas.axios + 'api', { query });
                this.establecimientos = response.data.data.allEstablecimientos.map(item => ({
                    value: item.id,
                    text: item.Descripcion,
                    uniCodigo: item.uniCodigo
                }));
                this.establecimientosMap = this.establecimientos.reduce((acc, est) => {
                    if (est.value !== null && est.value !== undefined) {
                        acc[String(est.value)] = est.text;
                    }
                    return acc;
                }, {});
            } catch (error) {
                console.error('An error occurred while fetching the options:', error);
            }
        },

        async descargarCartAten(){
            await this.fetchConsultarAtencionesMedicas('', 1, '', 15, '1', '1')
            this.descargandoExcel = false
        },


        async fetchConsultarAtencionesMedicas(search = '', pagina_actual = 1, establecimiento = '', pageSize, estado, excel) {


            const query = `
              query MyQuery(
                $page:Int
                $pageSize: Int
                $search: String
                $estado: String
                $establecimiento: String
                $excel : String
              ) {
                allCarteraAtencion(
                  page: $page
                  pageSize: $pageSize
                  search: $search
                  establecimiento: $establecimiento
                  estado: $estado
                  excel: $excel
                ) {
                  message
                  status
                  dataarchivo
                  total
                  atenciones {
                    token
                    descripcion
                    estado
                    id
                    precio
                    codTarifa
                    establecimiento
                  }
                }
              }
            `;
            const effectivePageSize = pageSize || this.perPage;
            const establecimientoParam = this.currentEstablecimiento && this.currentEstablecimiento.uniCodigo === '36451'
                ? (establecimiento ? String(establecimiento) : null)
                : (establecimiento ? String(establecimiento) : (this.currentEstablecimiento?.id ? String(this.currentEstablecimiento.id) : null));

            const var_consulta = {
                search: search,
                page: pagina_actual,
                pageSize: effectivePageSize,
                establecimiento: establecimientoParam,
                estado : estado ?? '',
                excel : excel
            }
            try {
                const response = await axios.post(rutas.axios + 'api', { query, variables: var_consulta });
                const dataGraph = response?.data?.data?.allCarteraAtencion;
                if (response.status === 200 && dataGraph) {
                    if (dataGraph.status === 'Success') {
                        const dataarchivo = dataGraph.dataarchivo
      
                        if(excel === '1'){
                            actions.cargarArchivos(dataarchivo, "CarteraAtenciones.xlsx", "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")
                            return
                        }
                        if (dataGraph.atenciones) {
                            this.items = dataGraph.atenciones.map(item => {
                                const estabList = (item.establecimiento || '')
                                  .split(',')
                                  .map(e => e.trim())
                                  .filter(Boolean);
                                const estabDisplay = estabList.map(entry => {
                                    const [idRaw, estadoRaw] = entry.split(':').map(val => val && val.trim());
                                    const id = idRaw || entry;
                                    const nombre = this.establecimientosMap[id] || id;
                                    const activo = estadoRaw ? estadoRaw !== '0' && estadoRaw.toLowerCase() !== 'inactivo' : true;
                                    return {
                                        id,
                                        nombre,
                                        activo,
                                    };
                                });

                                return {
                                    idAtencion: item.id,
                                    estado: item.estado,
                                    tokenAtencion: item.token,
                                    establecimientos: estabDisplay,
                                    descripcion: item.descripcion || "No disponible",
                                    codTarifa: item.codTarifa || "No disponible",
                                    usuario: item.usuarioCreador ? item.usuarioCreador.username : 'No disponible',
                                    estadoJson: {
                                      iess: item.estado === '1',
                                      issfa: item.estado === '1',
                                      isspol: item.estado === '1',
                                      particular: item.estado === '1',
                                    },
                                };
                            });

                            this.totalRows = response.data.data.allCarteraAtencion.total;
                            this.currentPage = 1;
                            this.currentPageModificado = pagina_actual;
                        } else {
                            console.log("No se encontraron atenciones");
                        }
                    } else {
                        console.log("Error en la respuesta del servidor");
                    }
                }
            } catch (error) {
                console.error("Error fetching imagenes:", error);
                // Aquí también podrías mostrar un mensaje de error en la interfaz de usuario
            }
        },
        buscarAtencion() {
            const establecimientoValue = this.consultarestablecimiento ? this.consultarestablecimiento.toString() : '';
            this.fetchConsultarAtencionesMedicas(this.consultaratencion ? this.consultaratencion : '', this.currentPage, establecimientoValue, 15, this.estado);

        },

        viewItem(tokenAtencion) {
            this.tokenAtencion = tokenAtencion;
            this.$bvModal.show("modal-ver-atencion");
        },

        editItem(tokenAtencion) {
            this.tokenAtencion = tokenAtencion;
            this.$bvModal.show("modal-editar-atencion");
        },

        async fetchRemoveItemAtencion(idAtencion) {

            this.$swal({
                title: 'Estas seguro de eliminar este item?',
                text: "No seras capaz de revertir esto!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, Borrar esto!',
                cancelButtonText: 'No, cancelar!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    // Call the API or method to remove the item here
                    try {
                        const argImg = {
                            id: idAtencion,
                        }
                        const response = await axios.post(rutas.axios + 'api', {
                            query: `mutation EliminarItemAtencion($id: ID!) {
                                        removerItemAtencion(id: $id) {
                                            status
                                            message
                                        }
                                    }
 `,
                            variables: argImg
                        });
                        if (response.status === 200) {
                            if (response.data.data.removerItemAtencion.status === 'success') {
                                if (response.status === 200) {
                                    this.$swal({
                                        title: 'Borrado!',
                                        text: 'Tu registro ha sido eliminado',
                                        icon: 'success',
                                        confirmButtonColor: '#3085d6'
                                    }).then((result) => {
                                        // This will only run when the user presses "OK" on the "Deleted!" modal
                                        if (result.isConfirmed) {
                                            this.$router.go(0);
                                        }
                                    });
                                }
                                this.$router.push({ name: 'cartera_atencion_medica' }).catch(err => {
                                    if (err.name !== 'NavigationDuplicated') {
                                        console.error(err);
                                    }
                                });
                            } else {
                                this.$swal({
                                    title: 'Error',
                                    text: response.data.data.removerItemAtencion.message,
                                    icon: 'error',
                                    confirmButtonColor: '#089599',
                                })
                            }
                        }
                    } catch (err) {
                        console.log(err);
                        return 'Error al eliminar doctor';
                    }
                } else {
                    // User clicked the cancel button
                    this.$swal({
                        title: 'Cancelado',
                        text: 'Your registro esta seguro :)',
                        icon: 'error',
                        confirmButtonColor: '#3085d6'
                    });
                }
            });
        },
        setToken() {
            const user = JSON.parse(localStorage.getItem('usuario'))
            this.login_user = user.username
            axios.defaults.headers.common.Authorization = `JWT ${user.token}`
        },

        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`
            this.infoModal.content = JSON.stringify(item, null, 2)
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },

        truncateTexto(texto, maxLength = 50) {
          if (!texto) return '';
          return texto.length > maxLength ? `${texto.slice(0, maxLength)}...` : texto;
        }
    },

    computed: {
      isXima() {
        return this.currentEstablecimiento?.uniCodigo === '36451';
      }
    }

}
</script>

<style scoped>
.col-estado {
  min-width: 180px;
}

.col-establecimientos,
.col-nombre {
  min-width: 260px;
}

.col-establecimientos span,
.col-nombre {
  word-break: break-word;
}
</style>
